import React from 'react';

const Header = (props) => {
  return <h1 className="header">{props.text}</h1>;
}

export default Header;



// WEBPACK FOOTER //
// ./src/Components/Header.js